import React, { createContext, useContext, useState } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { ChildrenProps } from '../../../../../../../types/common';
import { MeterConfigurationBody, MeterConfigurationServerError, MeterConfigurationState } from '../types';

const initialState: MeterConfigurationState = {
  form: {} as UseFormReturn<MeterConfigurationBody, any, MeterConfigurationBody>,
  formValues: {
    rules: [],
  },
  activeRuleIndex: 0,
  setActiveRuleIndex: () => null,
  serverErrors: {},
  setServerErrors: () => null,
  clearServerErrors: () => null,
};

export const MeterConfigurationContext = createContext(initialState);

export const useMeterConfigurationContext = (): MeterConfigurationState => useContext(MeterConfigurationContext);

const MeterConfigurationProvider: React.FC<ChildrenProps> = ({ children }) => {
  const [activeRuleIndex, setActiveRuleIndex] = useState<number>(initialState.activeRuleIndex);
  const [serverErrors, setServerErrors] = useState<MeterConfigurationServerError>(initialState.serverErrors);
  const form = useForm<MeterConfigurationBody>({
    defaultValues: initialState.formValues,
  });

  const formValues = form.watch();

  const clearServerErrors = () => setServerErrors(initialState.serverErrors);

  const values: MeterConfigurationState = {
    form,
    formValues,
    activeRuleIndex,
    setActiveRuleIndex,
    serverErrors,
    setServerErrors,
    clearServerErrors,
  };

  return <MeterConfigurationContext.Provider value={values}>{children}</MeterConfigurationContext.Provider>;
};

export default MeterConfigurationProvider;
